import { useState, useEffect } from "react";

import { InputSwitch } from "primereact/inputswitch";
import { ProgressBar } from "primereact/progressbar";
//
const Header = () => {
  //

  const [checked, setChecked] = useState(() => {
    const savedTheme = localStorage.getItem("primereact_theme");
    return savedTheme === "dark";
  });

  useEffect(() => {
    const body = document.getElementById("body");
    const nav = document.getElementById("nav_bar_id");
    const themeLink = document.getElementById("theme-link");

    if (checked) {
      body.classList.add("dark-mode");
      nav.classList.remove("navbar-light");
      nav.classList.remove("navbar-white");
      nav.classList.add("dark-mode");
      themeLink.href = "/prime_React_theme/lara-dark-blue/theme.css";
    } else {
      body.classList.remove("dark-mode");
      nav.classList.remove("dark-mode");
      nav.classList.add("navbar-light");
      nav.classList.add("navbar-white");
      themeLink.href = "/prime_React_theme/lara-light-cyan/theme.css";
    }
  }, [checked]);

  // nav side in mobiles doesnt apears correctly so click the header to show and hide the

  return (
    <>
      <div className="">
        <nav
          id="nav_bar_id"
          className="main-header navbar navbar-expand navbar-white navbar-light"
          onClick={() => document.getElementById("openCloseMenu").click()}
        >
          {/* Left navbar links */}
          <ul className="navbar-nav">
            <li className="nav-item">
              <a
                className="nav-link"
                data-widget="pushmenu"
                href="#"
                role="button"
              >
                <i id="openCloseMenu" class="fas fa-bars" />
              </a>
            </li>
          </ul>
          {/* Right navbar links */}
          <ul className="navbar-nav ml-auto">
            {/* Navbar Search */}

            <li className="nav-item">
              <InputSwitch
                checked={checked}
                onChange={(e) => setChecked(e.value)}
                style={{ margin: "5px" }}
                variant="success"
              />
            </li>
          </ul>
        </nav>
        {/* /.navbar */}
      </div>
    </>
  );
};

export default Header;
